import { Pipe, PipeTransform } from '@angular/core';
import { FieldChange } from 'src/lib/fliko/interfaces/fieldChange';
import { LocalizationService } from '../services/localization.service';

@Pipe({
  name: 'attHistory'
})
export class AttHistoryPipe implements PipeTransform {
  constructor(private ls: LocalizationService) {}

  transform<T extends string>(change: FieldChange<T>): string {
    const key = `history.${change.type}.${change.valueAfter ? (change.valueBefore ? 'edit' : 'add') : 'delete'}`;
    if (change.type != 'attachments' && change.type != 'photos') {
      console.warn('invalid attachment field key:', change.type);
    }
    return this.ls.translate(key);
  }
}
